import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleString();
}

export function formatDateShort(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString();
}

export function formatTime(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleTimeString();
}

export function formatDuration(startDate, endDate) {
  if (!startDate) return '-';
  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : new Date();
  const diffMs = end - start;
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
}

export function formatEnergy(kwh) {
  if (kwh === null || kwh === undefined) return '-';
  if (kwh >= 1000) {
    return `${(kwh / 1000).toFixed(2)} MWh`;
  }
  return `${kwh.toFixed(2)} kWh`;
}

export function formatCurrency(amount, currency = 'AED') {
  if (amount === null || amount === undefined) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'AED'
  }).format(amount);
}

export function formatPower(kw) {
  if (kw === null || kw === undefined) return '-';
  return `${kw.toFixed(1)} kW`;
}

export function getStatusColor(status) {
  const statusColors = {
    'Available': 'bg-emerald-700',
    'Preparing': 'bg-blue-700',
    'Charging': 'bg-blue-700',
    'SuspendedEV': 'bg-amber-700',
    'SuspendedEVSE': 'bg-amber-700',
    'Finishing': 'bg-purple-700',
    'Reserved': 'bg-indigo-700',
    'Unavailable': 'bg-gray-600',
    'Faulted': 'bg-red-700',
    'Finished': 'bg-gray-600',
    'online': 'bg-emerald-700',
    'offline': 'bg-gray-600'
  };
  return statusColors[status] || 'bg-gray-600';
}

export function getStatusTextColor(status) {
  const statusColors = {
    'Available': 'text-emerald-800 dark:text-emerald-300',
    'Preparing': 'text-blue-800 dark:text-blue-300',
    'Charging': 'text-blue-800 dark:text-blue-300',
    'SuspendedEV': 'text-amber-800 dark:text-amber-300',
    'SuspendedEVSE': 'text-amber-800 dark:text-amber-300',
    'Finishing': 'text-purple-800 dark:text-purple-300',
    'Reserved': 'text-indigo-800 dark:text-indigo-300',
    'Unavailable': 'text-gray-700 dark:text-gray-300',
    'Faulted': 'text-red-800 dark:text-red-300',
    'Finished': 'text-gray-700 dark:text-gray-300',
    'online': 'text-emerald-800 dark:text-emerald-300',
    'offline': 'text-gray-700 dark:text-gray-300',
    'Active': 'text-red-800 dark:text-red-300',
    'Acknowledged': 'text-amber-800 dark:text-amber-300',
    'Cleared': 'text-gray-700 dark:text-gray-300',
    'Critical': 'text-red-800 dark:text-red-300',
    'Major': 'text-amber-800 dark:text-amber-300',
    'Minor': 'text-blue-800 dark:text-blue-300'
  };
  return statusColors[status] || 'text-gray-700 dark:text-gray-300';
}

export function getSeverityColor(severity) {
  const colors = {
    'Critical': 'bg-red-700',
    'Major': 'bg-amber-700',
    'Minor': 'bg-blue-700'
  };
  return colors[severity] || 'bg-gray-600';
}

export function timeAgo(dateString) {
  if (!dateString) return 'Never';
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSecs < 60) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  return `${diffDays}d ago`;
}
